<template>
  <div class="live-play">
    <iframe allow="microphone;camera;midi;encrypted-media" :src="live_url" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  name: "LivePlay",
  data() {
    return {
      course_id: this.$route.query.course_id,
      chapter_id: this.$route.query.chapter_id,
      live_url: ""
    };
  },
  methods: {
    getUrl() {
      this.$http
        .get(
          `/api/app/getPcRoomCode/course_id=${this.course_id}/chapter_id=${this.chapter_id}`,
          {},
          'H5',
          data => {
            this.$toast({
              message: data.msg,
              duration: 1000
            });
            setTimeout(() => {
              this.$router.push({
                name: "Index"
              });
            }, 1000);
          }
        )
        .then(res => {
          this.live_url = res.chapterInfo.web_url;
        });
    }
  },
  created() {
    this.getUrl();
  }
};
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  min-height: 100vh;
}
</style>
